import { render, staticRenderFns } from "./TextItem.vue?vue&type=template&id=0e03fa32&scoped=true&"
import script from "./TextItem.vue?vue&type=script&lang=js&"
export * from "./TextItem.vue?vue&type=script&lang=js&"
import style0 from "./TextItem.vue?vue&type=style&index=0&id=0e03fa32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e03fa32",
  null
  
)

component.options.__file = "TextItem.vue"
export default component.exports